import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { IssueCardMain } from './IssueCardMain';
import { IssueCardConfirm } from './IssueCardConfirm';
import { IssueCardPlaced } from './IssueCardPlaced';

import { IssueCardStackParamList, IssueCardStackRoutes } from './type';

const IssueCardStack = createNativeStackNavigator<IssueCardStackParamList>();

export const IssueCardNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.IssueCard>> = ({ route }) => {
  const { account, tab, record, func, refresh, onChangeView } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <IssueCardStack.Navigator
          initialRouteName={IssueCardStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <IssueCardStack.Screen
            name={IssueCardStackRoutes.Main}
            component={IssueCardMain}
            initialParams={{ onLayout, onData, account, tab, record, func, onReturnData, refresh }}
            options={{ headerShown: false }}
          />
          <IssueCardStack.Screen
            name={IssueCardStackRoutes.Confirm}
            component={IssueCardConfirm}
            initialParams={{ onLayout, account, tab, record, func, data, onReturnData, refresh, onChangeView }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <IssueCardStack.Screen
            name={IssueCardStackRoutes.Placed}
            component={IssueCardPlaced}
            initialParams={{ onLayout, account, tab, record, data, returnData, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </IssueCardStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
